const MeatballsMenuIcon = () => {
  return (
    <svg
      width="54"
      height="15"
      viewBox="0 0 54 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13.0898C10.3137 13.0898 13 10.4036 13 7.08984C13 3.77614 10.3137 1.08984 7 1.08984C3.68629 1.08984 1 3.77614 1 7.08984C1 10.4036 3.68629 13.0898 7 13.0898Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        d="M27 13.0898C30.3137 13.0898 33 10.4036 33 7.08984C33 3.77614 30.3137 1.08984 27 1.08984C23.6863 1.08984 21 3.77614 21 7.08984C21 10.4036 23.6863 13.0898 27 13.0898Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        d="M47 13.0898C50.3137 13.0898 53 10.4036 53 7.08984C53 3.77614 50.3137 1.08984 47 1.08984C43.6863 1.08984 41 3.77614 41 7.08984C41 10.4036 43.6863 13.0898 47 13.0898Z"
        fill="white"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default MeatballsMenuIcon;
